import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    label: translate({ id: 'form.drivers.edit.fields.password.label' }),
    placeholder: translate({ id: 'form.drivers.edit.fields.password.label' }),
  }))

  return api
}
